import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProjectHeaderRefreshService {
    private refreshHeaderSubject = new Subject<void>();
    refresh = this.refreshHeaderSubject.asObservable();

    triggerHeaderRefresh() {
        this.refreshHeaderSubject.next();
    }
}
